export const replaceSpacesWithPlus = (text: string) => {
  if(!text) return ""
  const _text = text.replace(/\s/g, "+");
  return _text;
};
